<template>
    <div>
        <vs-popup class="product-modal" :title="getTitle" :active.sync="showPopup" v-if="currentProduct !== null">
            <template>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Naam"
                                :value="currentProduct.name"
                                v-model="currentProduct.name"
                        />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Omschrijving"
                                :value="currentProduct.description"
                                v-model="currentProduct.description"
                        />
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Prijs"
                                :value="currentProduct.price"
                                v-model="currentProduct.price"
                        />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="BTW"
                                :value="currentProduct.vat"
                                v-model="currentProduct.vat"
                        />
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-button class="mr-3 mb-2" @click.stop="saveProduct(currentProduct)">Opslaan</vs-button>
                    </div>
                </div>
            </template>
        </vs-popup>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currentProduct: null,
                showPopup: false
            }
        },

        computed: {
            getTitle: function() {

                if(!this.currentProduct.name) {
                    return 'Product';
                }
                return this.currentProduct.name + ' aanpassen';
            }
        },

        mounted() {
            this.$events.listen('open-product-modal', (event) => {
                this.currentProduct = event;
                this.showPopup = true;
                console.log(event);
            });
        },

        methods: {
            saveProduct(product) {
                let data = {
                    _method: 'PUT',
                    id: product.id,
                    name: product.name,
                    description: product.description,
                    price: product.price,
                    vat: product.vat,
                    position: product.position,
                    company_product_category_id: product.category.id,
                    category: product.category.id,
                    image: product.image
                };
                let url = '/v1/company/' + this.$route.params.slug + '/product/quickupdate';
                this.$http.post(url, data)
                    .then((response) => {
                        this.saved = true;
                        this.showPopup = false;
                        this.$events.fire('refresh-products');
                        this.$vs.notify({
                            title: "Gelukt!",
                            text: "Gegevens voor " + product.name + " zijn opgeslagen!",
                            color: "green",
                            position: "top-center",
                        });
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            }
        }
    }
</script>
